import { assertObjects } from '#app/lib/assert_types'
import type { BBox } from '#server/types/common'
import leafletLite from './leaflet_lite.ts'
import type { LatLng } from 'leaflet'

// Coordinates are returned in decimal degrees
// There is no need to keep more than 4 decimals, cf https://xkcd.com/2170/
// See https://developer.mozilla.org/en-US/docs/Web/API/GeolocationCoordinates
export function truncateDecimals (degree: number) {
  return Math.round(degree * 10000) / 10000
}

export function truncateBboxDecimals (bbox: BBox) {
  return bbox.map(truncateDecimals) as BBox
}

// a, b MUST be { lat, lng } coords objects
export function distanceBetween (a: LatLng, b: LatLng) {
  assertObjects([ a, b ])
  // return the distance in kilometers
  return leafletLite.distance(a, b) / 1000
}
